<template>
  <footer class="relative bg-white">
    <div class="bg-alto py-10">
      <div class="container py-8 max-w-[1200px] px-10 sm:mx-auto">
        <div class="flex flex-wrap sm:justify-between justify-center">
          <div class="w-full sm:w-4/12 px-4 sm:px-8">
            <div>
              <p class="font-light">
                CSV RAG is a tool to allow you to quickly upload a CSV data for use in Retrieval-Augmented Generation applications.
              </p>
              <router-link
                to="/"
                class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
              >
                <div class="flex mt-[18px]">
                  <img
                    src="/img/csvrag-logo.png"
                    class="w-[100px] h-[100px]"
                    alt="Power your RAG applications with a CSV"
                  />
                </div>
              </router-link>
              <p class="text-sm mt-5">Copyright © {{ date }}</p>
            </div>
          </div>
          <div class="w-full sm:w-4/12 pl-4 sm:pl-8 pt-10 sm-pt:0">
            <ul
              class="flex flex-col flex-wrap list-none sm:justify-end justify-center"
            >
              <li>
                <a :href="`${webBaseUrl}/auth/register`"
                  ><span class="py-3 md:py-1 block">Sign up</span></a
                >
              </li>
              <li>
                <a :href="`${webBaseUrl}/auth/login`"
                  ><span class="py-3 md:py-1 block">Log in</span></a
                >
              </li>
            </ul>
            <ul
              class="flex flex-col flex-wrap list-none sm:justify-end justify-center mt-5"
            >
              <li>
                <router-link to="/terms"
                  ><span class="py-3 md:py-1 block">Terms</span></router-link
                >
              </li>
              <li>
                <router-link to="/privacy"
                  ><span class="py-3 md:py-1 block">Privacy</span></router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
    if (import.meta.env.VITE_GOOGLE_ADS_ID && this.$hj) {
      const gclidPromise = new Promise((resolve) => {
        window.gtag(
          "get",
          import.meta.env.VITE_GOOGLE_ADS_ID,
          "gclid",
          resolve,
        );
      });
      gclidPromise.then((gclid) => {
        if (gclid) {
          this.$hj("event", "google_cpc");
        }
      });
    }
    if (this.$hj) {
      this.$hj("event", `session_referrer_${window.document.referrer}`);
    }
  },
};
</script>
